import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import "./LeaveManagement.css";
import axios from "./../../axios";
import TableComponentLevMang from "./TableComponentLVM/TableComponentLevMang";
import { toast } from "react-toastify";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

function LeaveManagement() {
  const schoolId = JSON.parse(localStorage.getItem("schoolId"));
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId")
  );
  const academicYearSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId")
  );
  const [classId, setClassId] = useState(null);
  const [sectionId, setSectionId] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [DisplayUIdDate, setDisplayUIdDate] = useState("");
  const [standardData, setStandardData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [isModified, setIsModified] = useState(false);
  const [activeTab, setActiveTab] = useState("Pending");
  const [approveLeaveDialog, setApproveLeaveDialog] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [pendingData, setPendingData] = useState([]);
  const [stdArr, setStdArr] = useState([]);
  const [dropdownLists, setDropdownLists] = useState({
    standards: null,
    sections: null,
  });
  const [rowData, setRowData] = useState({
    srNo: 0,
    studentName: "",
    rollCode: "",
    startDate: "",
    endDate: "",
    leaveReason: "",
    remarks: "",
    id: "",
  });
  const { standards, sections } = dropdownLists;
  const standardList = [];
  const sectionList = [];
  const CTRole_Information = JSON.parse(
    localStorage.getItem("role_as_class_teacher")
  );
  const CoRole_Information = JSON.parse(
    localStorage.getItem("role_as_co_ordinator")
  );
  const general_role = JSON.parse(localStorage.getItem("general_role"));

  const fetchClasses = async () => {
    try {
      const standardRes = await axios.get(
        `/api/v1/school/standard/get/school/${schoolId}`
      );
      setStandardData(standardRes?.data?.data);
    } catch (error) {
      console.error("Error fetching class data:", error);
    }
  };
  const fetchSection = async () => {
    try {
      const sectionRes = await axios.get(
        `/api/v1/school/section/get/school/${schoolId}`
      );
      setSectionData(sectionRes?.data?.data);
    } catch (error) {
      console.error("Error fetching class data:", error);
    }
  };

  // When standards arrive, set first one as default
  useEffect(() => {
    if (standards?.length > 0 && !classId) {
      // pick first item after sorting
      const sortedStandards = [...standards].sort((a, b) => {
        const aNum = Number(a.name);
        const bNum = Number(b.name);

        const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
        if (bothNumeric) return aNum - bNum;

        return a.name.localeCompare(b.name);
      });

      setClassId(sortedStandards[0].id);
      handleClassChange(sortedStandards[0].id); // also trigger your handler
    }
  }, [standards]);

  // When sections arrive, set first one as default
  useEffect(() => {
    if (sections?.length > 0 && !sectionId) {
      const sortedSections = [...sections].sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      setSectionId(sortedSections[0].id);
      handleSectionChange(sortedSections[0].id); // also trigger your handler
    }
  }, [sections]);

  const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";

    const dateParts = dateStr.split(" ");
    if (dateParts.length < 4) return "";

    const day = parseInt(dateParts[1], 10);
    const month = new Date(`${dateParts[2]} 1, 2000`).getMonth();
    const year = parseInt(dateParts[3], 10);

    const date = new Date(Date.UTC(year, month, day));

    return date.toISOString().split("T")[0];
  };

  useEffect(() => {
    fetchClasses();
    fetchSection();
  }, [schoolId, academicYearSessionId]);

  const handleClassChange = (value) => {
    setClassId(value);
    setIsModified(false);
    setSectionId(null);
  };
  const handleSectionChange = (value) => {
    setSectionId(value);
    setIsModified(false);
  };

  // useEffect(() => {
  //   if (CTRole_Information && CTRole_Information.length > 0) {
  //     CTRole_Information?.forEach((obj) => {
  //       if (obj.is_class_teacher === true) {
  //         if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //           standardList.push(obj.standard_id);
  //         }
  //         if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //           sectionList.push(obj.section_id);
  //         }
  //       }
  //     });
  //   }

  //   if (CoRole_Information && CoRole_Information.length > 0) {
  //     CoRole_Information?.forEach((obj) => {
  //       if (obj?.is_class_co_ordinator === true) {
  //         if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //           standardList.push(obj.standard_id);
  //         }
  //         if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //           sectionList.push(obj.section_id);
  //         }
  //       }
  //     });
  //   }
  //   // if (general_role && general_role.length > 0) {
  //   //     general_role?.forEach((obj) => {
  //   //         console.log("obj in gen", obj)
  //   //         if (obj.is_class_co_ordinator === false &&
  //   //             obj.is_class_teacher === false) {
  //   //             if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //   //                 standardList.push(obj.standard_id);
  //   //             }
  //   //             if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //   //                 sectionList.push(obj.section_id);
  //   //             }
  //   //         }

  //   //     });
  //   // }
  //   standardList.length > 0 &&
  //     setDropdownLists((prev) => ({ ...prev, standards: standardList }));

  //   sectionList.length > 0 &&
  //     setDropdownLists((prev) => ({ ...prev, sections: sectionList }));

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  let sectionArr = [];
  let standardArr = [];
  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj)
        )
      ) {
        standardArr.push(obj);
      }
    }
    CTRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id)
    );
    CoRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id)
    );
  };

  dropDownHelper();

  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    CTRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === classId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    CoRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === classId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();

  const columns = [
    { header: "Sr. No", accessorKey: "srNo" },
    { header: "Name", accessorKey: "studentName" },
    { header: "Roll Code", accessorKey: "rollCode" },
    { header: "Start Date", accessorKey: "startDate" },
    { header: "End Date", accessorKey: "endDate" },
    { header: "leave Reason", accessorKey: "leaveReason" },
    { header: "Remarks", accessorKey: "remarks" },
    ...(activeTab === "Pending"
      ? [{ header: "Actions", accessorKey: "actions" }] // ✅ No "cell" function
      : []),
  ];

  const fetchData = async () => {
    if (schoolId && classId && sectionId) {
      const body = {
        academicSessionId: academicYearSessionId,
        timetableSessionId: timeTableSessionId,
        standardId: classId,
        sectionId: sectionId,
        status: activeTab,
      };
      try {
        const response = await axios.get(
          `/api/v1/leaveMngmt/getLeavesByStatus?academicSessionId=${academicYearSessionId}&timetableSessionId=${timeTableSessionId}&standardId=${classId}&sectionId=${sectionId}&status=${activeTab}`,
          body
        );
        if (response) {
          setPendingData(response?.data?.data);
        }
      } catch (err) {
        console.log("err", err);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [classId, sectionId, activeTab]);

  const handleStatusChange = (newStatus) => {
    setApplyFunction(rowData?.id ?? "", newStatus);
  };

  const setApplyFunction = async (id, status) => {
    const payload = {
      leaveId: id,
      status: status,
      remark: remarks || "",
    };
    try {
      const res = await axios.post(`/api/v1/leaveMngmt/statusChange`, payload);
      if (res) {
        toast.success(res?.data?.message);
        setApproveLeaveDialog(false);
        setRemarks("");
        fetchData();
      }
    } catch (err) {
      toast.error(err?.data?.message);
    }
  };

  const rows = React.useMemo(() => {
    return pendingData
      ?.sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      )
      .map((item, index) => {
        const formatDate = (dateStr) => {
          if (!dateStr) return "N/A";
          const date = new Date(dateStr);
          return date
            .toLocaleDateString("en-GB", {
              month: "short",
              year: "numeric",
              weekday: "short",
              day: "2-digit",
            })
            .replace(",", "");
        };
        return {
          srNo: index + 1,
          studentName: item?.student?.name || "N/A",
          rollCode: item?.student?.code || "N/A",
          startDate: formatDate(item.startDate),
          endDate: formatDate(item.endDate),
          leaveReason: item?.reason || "N/A",
          remarks: item?.teacherRemark || "N/A",
          id: item?.id,
        };
      });
  }, [pendingData]);

  return (
    <div
      style={{
        margin: "10px 0px",
        overflow: "hidden",
        height: "630px",
      }}
    >
      <div className="card h-100">
        <h2 className="card-header">Leave Management</h2>
        <div className="d-flex align-items-center gap-4 flex-row mb-4">
          <FormControl size="small" fullWidth>
            <InputLabel>Class*</InputLabel>
            <Select
              label="Class*"
              value={classId || ""}
              onChange={(e) => handleClassChange(e.target.value)}
            >
              {standardArr?.length > 0 &&
                [...standardArr]
                  .sort((a, b) => {
                    const aNum = Number(a.name);
                    const bNum = Number(b.name);

                    const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                    if (bothNumeric) {
                      return aNum - bNum; // numeric sort
                    }

                    return a.name.localeCompare(b.name); // alphabetical sort
                  })
                  .map((standard, index) => (
                    <MenuItem
                      key={index}
                      value={standard?.id}
                      name={standard?.name}
                    >
                      {standard?.name}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
          <FormControl size="small" fullWidth>
            <InputLabel>Section*</InputLabel>
            <Select
              label="Section*"
              value={sectionId || ""}
              onChange={(e) => handleSectionChange(e.target.value)}
            >
              {sectionArr
                ?.slice()
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((section) => (
                  <MenuItem key={section.id} value={section.id}>
                    {section.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>

        {!classId || !sectionId ? (
          <Box
            sx={{
              width: "100%",
              minHeight: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // background: "linear-gradient(135deg, #e3f2fd, #ffffff)",
              // borderRadius: "16px",
              px: 2,
              py: 4,
            }}
          >
            <Box
              sx={{
                textAlign: "center",
                px: 4,
                py: 3,
                borderRadius: "18px",
                // background: "rgba(255,255,255,0.7)",
                // backdropFilter: "blur(10px)",
                // boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: "#1e3a8a", // deep blue
                  mb: 1,
                }}
              >
                Please select
                <Box
                  component="span"
                  sx={{
                    color: "#ff6f00", // classic orange
                    fontWeight: 800,
                  }}
                >
                  {" "}
                  Class{" "}
                </Box>
                and
                <Box
                  component="span"
                  sx={{
                    color: "#ff6f00",
                    fontWeight: 800,
                  }}
                >
                  {" "}
                  Section
                </Box>
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "#374151",
                  mt: 1,
                  fontWeight: 500,
                }}
              >
                to view student leave details
              </Typography>
            </Box>
          </Box>
        ) : (
          <>
            {/* Tabs Section */}
            <div className="col-lg-3 col-md-4 col-12 p-0 m-0 d-flex align-items-center ">
              <button
                className={` ${
                  activeTab === "Pending"
                    ? "active sub_main_three_button_active mx-2"
                    : "sub_main_three_button mx-2"
                }`}
                onClick={() => setActiveTab("Pending")}
              >
                Pending
              </button>
              <button
                className={` ${
                  activeTab === "Approved"
                    ? "active sub_main_three_button_active mx-2"
                    : "sub_main_three_button mx-2"
                }`}
                onClick={() => setActiveTab("Approved")}
              >
                Approved
              </button>
              <button
                className={` ${
                  activeTab === "Rejected"
                    ? "active sub_main_three_button_active mx-2"
                    : "sub_main_three_button mx-2"
                }`}
                onClick={() => setActiveTab("Rejected")}
              >
                Rejected
              </button>
            </div>
            {/* Tabs Content */}
            <div className="tab-content">
              {activeTab === "Pending" && (
                <div className="h-100">
                  <TableComponentLevMang
                    setApproveLeaveDialog={setApproveLeaveDialog}
                    setRowData={setRowData}
                    columns={columns}
                    data={rows}
                  />
                </div>
              )}
              {activeTab === "Approved" && (
                <TableComponentLevMang
                  setApproveLeaveDialog={setApproveLeaveDialog}
                  setRowData={setRowData}
                  columns={columns}
                  data={rows}
                />
              )}
              {activeTab === "Rejected" && (
                <TableComponentLevMang
                  setApproveLeaveDialog={setApproveLeaveDialog}
                  setRowData={setRowData}
                  columns={columns}
                  data={rows}
                />
              )}
            </div>
          </>
        )}

        {/* Modal (Approval Dialog) */}
        {approveLeaveDialog && (
          <div className="modal">
            <div className="modal-content">
              <img
                src="/images/cross-circle3.svg"
                className="subPrereadClosetBtn"
                alt=""
                onClick={(e) => setApproveLeaveDialog(false)}
              />
              <h3 style={{ textAlign: "center" }}>Leave Request</h3>
              <label>Leave Start Date</label>
              <input
                type="date"
                class="form-control"
                value={
                  rowData?.startDate
                    ? formatDateForInput(rowData?.startDate)
                    : ""
                }
                disabled
              />

              <label>Leave End Date</label>
              <input
                type="date"
                class="form-control"
                value={
                  rowData?.endDate ? formatDateForInput(rowData?.endDate) : ""
                }
                disabled
              />

              <label>Leave Reason</label>
              <input
                type="text"
                value={rowData?.leaveReason}
                class="form-control"
                disabled
              />

              <label>Teacher Remarks</label>
              <input
                type="text"
                class="form-control"
                placeholder="Remarks (If any)"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />

              <div className="modal-actions">
                <button
                  style={{ borderRadius: "7px" }}
                  onClick={() => handleStatusChange("Pending")}
                >
                  More Info
                </button>
                <button
                  style={{ borderRadius: "7px" }}
                  className="danger"
                  onClick={() => handleStatusChange("Rejected")}
                >
                  Reject
                </button>
                <button
                  style={{ borderRadius: "7px" }}
                  className="success"
                  onClick={() => handleStatusChange("Approved")}
                >
                  Approve
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LeaveManagement;
